// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_02712f2b3b--wrapper--je9uq","icon":"_02712f2b3b--icon--q_vp8","title":"_02712f2b3b--title--zyDrK","message":"_02712f2b3b--message--LGHd_"};